import React from 'react';
import Tooltip from '@amzn/meridian/tooltip';
import { IMAGE_STYLE, IMAGE_STYLE_LARGE } from '@constants/values';
import userTokens from '@amzn/meridian-tokens/base/icon/user';
import Icon from '@amzn/meridian/icon';

export const ImageCellRenderer = (props: { value: string }) => {
  const { value } = props;
  return (
    <Tooltip
      position="end"
      title={
        value ? (
          <img alt="product" className={IMAGE_STYLE_LARGE} src={value.toString()} />
        ) : (
          <Icon className={IMAGE_STYLE} tokens={userTokens} />
        )
      }
      id="myTooltip"
    >
      {value ? (
        <img alt="product" className={IMAGE_STYLE} src={value.toString()} />
      ) : (
        <Icon className={IMAGE_STYLE} tokens={userTokens} data-testid="icon-component" />
      )}
    </Tooltip>
  );
};

export default ImageCellRenderer;
